<template>
    <v-dialog
        width="unset"
        v-bind:value="value"
        v-bind:fullscreen="$vuetify.breakpoint.mobile"
        v-on:input="$emit('input', $event)"
    >
        <v-card tile class="pb-4">
            <v-toolbar dark color="primary">
                <v-btn icon dark v-on:click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>New cash transaction</v-toolbar-title>
            </v-toolbar>
            <v-card-text v-if="courierinfo.user != null" class="pb-0 pt-4">
                Target: <strong>{{ courierinfo.user.name }}</strong
                ><br />
                Date:
                <strong>{{ new Date(date) | date('dd-MMM-yyyy') }}</strong>
            </v-card-text>
            <v-form class="ma-4">
                <v-text-field
                    filled
                    autofocus
                    type="number"
                    label="Amount"
                    prepend-inner-icon="mdi-account-plus"
                    v-model="cashtransaction.amount"
                    append-icon="mdi-currency-inr"
                ></v-text-field>
                <v-text-field
                    filled
                    label="Description"
                    prepend-inner-icon="mdi-text"
                    v-model="cashtransaction.description"
                ></v-text-field>
            </v-form>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn class="mx-2" v-on:click="save">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        // Value of v-dialog. Controls show/hide
        value: {
            type: Boolean,
            required: true
        },
        // Used only for to pass in values
        // Final value should be read from save event
        cashtransaction: {
            type: Object,
            required: true
        },
        courierinfo: {
            type: Object,
            required: true
        },
        date: {
            type: String,
            required: true
        }
    },
    methods: {
        save() {
            this.$emit('request-save', {
                courierinfoId: this.courierinfo.id,
                cashtransaction: this.cashtransaction
            });
            this.close();
        },
        close() {
            this.$emit('input', false);
        }
    }
};
</script>

<style scoped>
/* Remove stepper on v-text-field type number */
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
